export default __webpack_public_path__ + "static/media/calendar-alt-white.26708db8.svg";